module.exports = __webpack_public_path__ + "img/t-shirt.a9e921b4.svg";